/**
 * Check if the values are separated always by the same difference
 * @param array - monotone growing array of number.
 * @param options - options.
 */
export function xIsEquallySpaced(array, options = {}) {
    if (array.length < 3)
        return true;
    const { tolerance = 0.05 } = options;
    let maxDx = 0;
    let minDx = Number.MAX_SAFE_INTEGER;
    for (let i = 0; i < array.length - 1; ++i) {
        const absoluteDifference = array[i + 1] - array[i];
        if (absoluteDifference < minDx) {
            minDx = absoluteDifference;
        }
        if (absoluteDifference > maxDx) {
            maxDx = absoluteDifference;
        }
    }
    return (maxDx - minDx) / maxDx < tolerance;
}
//# sourceMappingURL=xIsEquallySpaced.js.map